<template>
    <div class="row">
        <div class="col-12" v-if="isAdmin">
            <card card-body-classes="" no-footer-line>
                <h4 slot="header" class="card-title text-right" v-if="event">
                    <n-button
                        @click.native="handleEdit(event.slug)"
                        class="edit"
                        type="warning"
                        size="sm"
                        round
                        simple
                    >
                        <i class="fa fa-pencil"></i> Edit
                    </n-button>
                </h4>
                <PreviewForm v-if="event" v-bind="event" entity="event"  @on-pool="gotParticipants" :withSubmit="event.isOpen"></PreviewForm>
                <!-- <div class="events mt-5" v-if="event">
                    <p class="card-text">Events</p>
                    <tabs type="primary">
                    <tab-pane :label="event.title" v-for="(event, index) in event.events" :key="index">
                        <PreviewForm v-bind="event" entity="event" :participants_pool="event.participants_pool" :withSubmit="false"></PreviewForm>
                    </tab-pane>
                    </tabs>
                </div> -->
            </card>
        </div>
        <div class="col-12" v-else>
            <!-- <card card-body-classes="" no-footer-line> -->
                <RegisterForm v-if="event" v-bind="event" entity="event"  @on-pool="gotParticipants" :withSubmit="event.isOpen"></RegisterForm>
                <p v-else>Sorry, details could not be loaded at the moment, please check if any <b>adblocker</b> is enabled or try later.</p>
                <!-- <div class="events mt-5" v-if="event.type == 'group'">
                    <p class="card-text">Events</p>
                    <tabs type="primary">
                    <tab-pane :label="event.title" v-for="(event, index) in event.events" :key="index">
                        <RegisterForm v-bind="event" entity="event" :participants_pool="event.participants_pool" :withSubmit="false"></RegisterForm>
                    </tab-pane>
                    </tabs>
                </div> -->
            <!-- </card> -->
            <!-- <div class="row">
                <div class="col-md-3" v-for="(event, index) in event.events" :key="index">
                    <PreviewCard v-bind="event" entity="event" v-on:card-click="onCardClick"></PreviewCard>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import { PreviewForm, RegisterForm, PreviewCard, Tabs, TabPane, } from "src/components";
import swal from "sweetalert2";

import { mapGetters } from 'vuex';

export default {
    components: {
        PreviewForm,
        RegisterForm,
        PreviewCard,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    computed: {
        ...mapGetters({
            event: 'getEvent',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences'
        }),
        isAdmin(){
            return (this.user) ? this.user.roles.includes('admin') : false
        }
    },
    data() {
        return {
            user: null
        };
    },
    methods: {
        handleEdit(slug) {
            this.$router.push(`/events/edit/${slug}`)
        },
        gotParticipants(pool){
        // Note:- Work around for this.event.participants_pool = pool
        // Vue is not reactive for such changes
        // https://vuejs.org/v2/guide/list.html#Object-Change-Detection-Caveats
        // Vue does not allow dynamically adding new root-level reactive properties to an already created instance.
        // However, it’s possible to add reactive properties to a nested object using the Vue.set(object, propertyName, value) 
        this.$set(this.event, 'participants_pool', pool)
        },
        onCardClick(link){
            this.$router.push(`/events/view/${link}`)
        }
    },
    mounted() {
        this.$store.commit('setEvent', null)
        this.$store.dispatch('getEvent', this.$route.params.slug);
        // get the currentUser from localStorage
        let user = localStorage.getItem('app_user')
        this.user = (user) ? JSON.parse(user) : null;

    },
    watch: {
    }
};
</script>
<style lang="scss">
</style>

